import {Component, OnInit, ViewChild} from '@angular/core';
import {IonInfiniteScroll, NavController} from "@ionic/angular";

import {ApiService} from "@services/api.service";
import {HttpService} from "@services/http/http.service";
import {UiHelperService} from "@services/ui-helper/ui-helper.service";
import {NavParamsService} from "@services/navParams/nav-params.service";

import {appRoutingEnum} from "@enums/appRoutingEnum";

import {StandardResponse} from "@interfaces/general.types";
import {Router} from "@angular/router";

@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.page.html',
  styleUrls: ['./inbox.page.scss'],
  standalone:false
})
export class InboxPage implements OnInit {
  @ViewChild('infiniteScroll', {static: true}) infiniteScroll!: IonInfiniteScroll

  chatWith: any;
  userIndex: any;
  user: any = {};
  params = {results: {per_page: 20, current_page: 1, loader: true}, userIndex: 0};
  users: any;
  texts: any = {};
  loadMoreResults: any = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParamsService,
    public api: ApiService,
    public http: HttpService,
    private uiHelper: UiHelperService,
    public router: Router
  ) {

    this.uiHelper.presentLoader();
    this.initPage();

  }

  initPage(){
    this.http.get(this.http.url + '/user/contacts/perPage:' + this.params.results.per_page + '/page:' + this.params.results.current_page).subscribe((data: any) => {
      this.users = data.allChats;
      this.texts = data.texts;
      this.uiHelper.hideLoader();
      if (data.allChats.length < this.params.results.per_page) {
        this.params.results.loader = false;
      }
    }, error => {
      console.log(error);
      this.uiHelper.hideLoader();
    });
  }

  /**
   * Loads more inbox shorts from the server, and render them.
   * @param infiniteScroll
   * @returns StandardResponse
   * @type {(infiniteScroll: IonInfiniteScroll)=>StandardResponse}
   */
  loadMoreDialogues(infiniteScroll: Event): StandardResponse {
    let response: StandardResponse = {success: false, message: 'Nothing done yet'};
    if (this.params.results.loader) {
      ++this.params.results.current_page;
      if (this.loadMoreResults) {
        this.loadMoreResults = false;
        this.http.get(this.http.url + '/user/contacts/perPage:' + this.params.results.per_page + '/page:' + this.params.results.current_page)
          .subscribe((data: any) => {
              this.loadMoreResults = true;
              data.allChats.forEach((item:any) => this.users.push(item));
              if (data.allChats.length < this.params.results.per_page) {
                this.params.results.loader = false;
              }
              response = {success: true, message: 'more chats loaded', data, result: data.allChats};
            }, err =>
              response = {
                success: false,
                message: 'An error has occurred, see more in the data field',
                data: err
              }
          )
      }
    }
    // @ts-ignore
    infiniteScroll.target.complete().then();
    return response;
  }

  ionViewDidLoad() {
  }

  ionViewWillEnter() {
    if (this.chatWith) {
      if (this.chatWith.user.userId == 0) {
        this.users.slice(this.userIndex, 1);
      } else {
        this.http.get(this.http.url + '/user/inbox/' + this.chatWith.user.userId).subscribe((data: any) => {
          if (data.res) {
            this.users[this.userIndex] = data.res;
          } else {
            this.users.slice(this.userIndex, 1);
          }
        });
      }
    }

    this.api.pageName = appRoutingEnum.INBOX;
  }

  /**
   * Navigates to a dialog with the given user, and updates the selected users index.
   * @param user - The user we are chatting with.
   * @param index - The index of the user we are chatting with.
   */
  goToDialogPage(user: any, index: number) {
    this.chatWith = user;
    this.userIndex = index;
    // this.navParams.state.next({user: user.user})
    this.router.navigate([appRoutingEnum.DIALOG + '/' + (user.user.id ?? user.user.userId)]).then();
  }

  deleteDialog(user:any, index: number){
    if(user.user.id != 1) {
      //this.users.slice(index, 1);
      this.http.post(this.http.url + '/user/dialog/delete/' + (user.user.id ?? user.user.userId), {}).subscribe((data: any) => {
        this.initPage();
      });
    }
  }

  ngOnInit() {
  }

}
